// extracted by mini-css-extract-plugin
module.exports = {"root":"_6a1dba","grey":"_5201c8","teal":"_3008fd"};